var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g3, _path23, _path24, _path25, _path26, _g4, _path27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagForAscensionIsland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26117",
    gradientUnits: "userSpaceOnUse",
    x1: -1706.416,
    x2: -1705.416,
    gradientTransform: "matrix(1.972 -1.9014 -2.3361 -1.2306 7188.126 -1233.376)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#288549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#288549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26118",
    gradientUnits: "userSpaceOnUse",
    x1: -1426.487,
    x2: -1425.487,
    gradientTransform: "matrix(4.2109 1.6428 -2.7757 3.3581 11406.147 -4099.373)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#288549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#288549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26119",
    gradientUnits: "userSpaceOnUse",
    x1: -1740.867,
    x2: -1739.866,
    gradientTransform: "matrix(-.6286 -2.665 -2.2494 1.3805 3029.934 -7118.667)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#288549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#288549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26120",
    gradientUnits: "userSpaceOnUse",
    x1: 47.56,
    x2: 52.91,
    gradientTransform: "matrix(1 0 0 -1 0 66)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#288549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#288549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26121",
    gradientUnits: "userSpaceOnUse",
    x1: -1458.591,
    x2: -1457.591,
    gradientTransform: "rotate(45 10033.28 17957.933) scale(6.6516)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#288549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#288549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26122",
    gradientUnits: "userSpaceOnUse",
    x1: -1618.009,
    x2: -1617.009,
    gradientTransform: "matrix(1.1995 -5.0853 4.2924 2.6342 -5986.943 -13088.627)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#288549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#288549"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2a5f9e",
    d: "M11.9 12h20.8v20.8H11.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M18.8 8.1V14h-7.3l14.4 18h6v-7.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9 2v30h-30c0 16.6 13.4 30 30 30s30-13.4 30-30s-13.5-30-30-30",
    fill: "#2a5f9e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 18.9h-6c-1.9 4-3 8.4-3 13.1h12V13.9h-3v5",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed4c5c",
    d: "M31.9 27.1L18.9 11h-6l17 21h2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 5v6h-7.9v3h21V2c-4.7 0-9.2 1.1-13.1 3",
    fill: "#ffffff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9 5H18.8c-6.1 2.9-11 7.9-13.9 13.9V32h6V11h21V5",
    fill: "#ed4c5c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9 27.9c.6-1.5 1.9-2.4 3-2c.3.1.6.3.7.6c-.1-.9-.5-1.7-1.2-2c-1.1-.4-2.5.5-3 2c-.4 1.1-.3 2.2.2 2.9c.1-.4.1-.9.3-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1 24.5c-1.1-.4-2.4.5-3 2c-.3.7-.3 1.3-.2 1.9c-.5.4-1.2.6-2 .7c-.6 0-1.1 0-1.5-.2c.5.7 1.6 1.1 2.7 1.1c1.6-.1 2.9-1.1 2.8-2.3c0-.4-.2-.8-.5-1.1c.6-.6 1.5-.9 2.2-.7c.3.1.6.3.7.6c0-1-.5-1.7-1.2-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6 27.6c-1-1.1-2.3-1.4-2.9-.5c-.2.2-.3.5-.3.8c-.3-.9-.2-1.7.2-2.3c.7-.8 2-.6 2.9.5c.7.8 1 1.9.9 2.7c-.2-.4-.5-.9-.8-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2 27.1c.5-1.1.2-2.2-.6-2.4c-.2-.1-.5 0-.8 0c.5-.5 1.2-.8 1.8-.6c.9.2 1.1 1.3.6 2.4c-.4.8-1.1 1.4-1.8 1.6c.4-.2.7-.6.8-1"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6 31.8s.1 5.1.1 5.5c.1.5.4 3.4 4.5 5.1c0 0 3.2-1.4 4-3.3c.8-1.9.7-5.5.7-5.5v-2l-9.3.2",
    fill: "#000000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43 32.2s.1 4.7.1 5.1c.1.4.3 3.1 4.2 4.7c0 0 3-1.3 3.8-3c.8-1.8.6-5.1.6-5.1v-1.8l-8.7.1",
    fill: "#ffffff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#1b81b6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7 33.7l-1.2-.4l-1.6.7l-1.6-.5l-1.4.5l-1.7-.7l-1.2.5v1.6l1.2-.5l1.7.7l1.4-.5l1.6.5l1.6-.7l1.3.4l-.1-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9 39.4c.1 0 2.1.6 2.1.6l1.4-.6l1.6.6s1.8-.7 2-.7c.5.1-2.7 2.7-3.6 2.7c-.8.1-4-2.4-3.5-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4 38c-.2-.1-1-.3-1-.3l-1.5.7l-1.6-.6l-1.4.6l-1.6-.7s-.8.2-1 .4c-.1.1-.2-1.2-.2-1.2l1.2-.5l1.6.7l1.4-.6l1.6.6l1.5-.7l1.3.4c-.1 0-.2 1.3-.3 1.2"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7 39.7l-.1.1l.1-.1m-3.2-5.5l-4.1 4.4c.2.4.4.8.7 1.3l3.4-3.5l3.2 3.4c.3-.4.6-.9.7-1.4l-3.9-4.2",
    fill: "url(#IconifyId17ecdb2904d178eab26121)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6 28.3l.6 1.4h4.2l.6-1.4l-2.7-6.4z",
    fill: "#000000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#7ed16d",
    d: "M44.8 28.1l.6 1.4h3.8l.5-1.4l-2.4-5.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#93695a",
    d: "M44.1 26.9l2.1 2.6l2.6-.1l.5-1.8l-1.8-.1l-1.2.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1 29.1l-3.2.9l1.5 1.8v1.7l1.6-.2s.8-1.5.9-1.5c.1 0 1.5.5 1.5.5l.3-.8l1.8-.6l-3.1-.9l.1-.8l-1.4-.1",
    fill: "#6baaa7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9 29.8c-.6.3-1.2.5-1.8.4c.7-.1 1.4-.7 1.6-1.4c.2-.8 0-1.6-.6-2.1c.1.4.1.7 0 1.1c-.3 1.1-1.5 1.9-2.6 1.4c-.5-.2-.6-.9-.6-1.2c-.3.7-.4 1.5 0 2.2c-.1.1-.1.2-.2.3c-.4 1 .1 2.1 1.1 2.4c.7.3 1.5.1 2-.4c-.3.1-.7 0-1-.1c-.6-.2-1-.7-1.1-1.2c.9.7 2.1.8 3.1.2c.9-.6 1.3-1.6 1.2-2.6c-.3.3-.6.7-1.1 1",
    fill: "url(#IconifyId17ecdb2904d178eab26120)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6 25.9c.5 1.5.1 3.1-1 3.5c-.3.1-.6.1-.9 0c.6.7 1.5 1 2.2.7c1.1-.4 1.6-1.9 1-3.5c-.4-1.1-1.2-1.9-2-2.1c.2.4.5.9.7 1.4",
    fill: "url(#IconifyId17ecdb2904d178eab26122)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 27.2c-.3.8 0 1.6.5 1.8c.2.1.3.1.5 0c-.3.4-.8.5-1.1.4c-.6-.2-.8-1-.5-1.8c.2-.6.6-1 1.1-1.1c-.3.2-.4.4-.5.7",
    fill: "url(#IconifyId17ecdb2904d178eab26119)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58 25.4c-.8.2-1.4.8-1.3 1.4c0 .2.1.3.2.4c-.5-.1-.8-.4-.9-.8c-.1-.6.5-1.2 1.3-1.4c.6-.1 1.2 0 1.5.4H58",
    fill: "url(#IconifyId17ecdb2904d178eab26117)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9 27.5c-1.3.3-2.5-.4-2.7-1.5c-.1-.3 0-.6.1-.9c-.6.5-1 1.3-.8 2.1c.2 1.1 1.4 1.8 2.7 1.5c.9-.2 1.7-.9 1.9-1.7c-.3.1-.7.3-1.2.5",
    fill: "url(#IconifyId17ecdb2904d178eab26118)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 43.3c-1.3-.5 2.9-2.7 4.7-2.6c1.4.1 4.2 2.5 3.2 2.8c-4.9 1.3-4.8 1-7.9-.2",
    fill: "#74948f"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6 31.8c.1-.4.5-1.2.8-1.5c.3-.3 1.1-.6 1.5-.5c.3 0 1 .4.9.6h-.3c-.3.1-.4.9-.6 1.2c-.2.2-.8.3-.9.5c-.1.2.1 1 .1 1l-1.5.1s-.1-1 0-1.4",
    fill: "#e5c9bd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41 36.9c0 .1.7 1.8.9 2.5c.3 1.2-1.6 3.3-1.5 2.3c.2-1.3-.5-2.6-.5-2.6l1.1-2.2",
    fill: "#c6a397"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#e5c9bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 37.9c-.1.1.1 1.9.1 2.6c-.1 1.3-2.5 2.6-2.1 1.7c.6-1.2.3-2.6.3-2.6l1.7-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5 33.3c0 .1 1.6 1.1 2.1 1.5c.9.9.5 3.6.1 2.7c-.6-1.2-1.8-1.9-1.8-1.9l-.4-2.3"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32.4c-1.2.1-2.9 2.5-3.4 3.6c-.5 1.2-1.2 5-.5 5.2c.9.3 3.9-2 4.6-3.3c.6-1 .9-3.6.4-4.7c0-.2-.7-.8-1.1-.8",
    fill: "#d66b3c"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6 43.3c1.3-.5-2.9-2.7-4.7-2.6c-1.4.1-4.2 2.5-3.2 2.8c4.9 1.3 4.7 1 7.9-.2",
    fill: "#74948f"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1 31.8c-.1-.4-.5-1.2-.8-1.5c-.3-.3-1.1-.6-1.5-.5c-.3 0-1 .4-.9.6h.3c.3.1.4.9.6 1.2c.2.2.8.3.9.5c.1.2-.1 1-.1 1l1.5.1c-.1 0 .1-1 0-1.4",
    fill: "#e5c9bd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7 36.9c0 .1-.7 1.8-.9 2.5c-.3 1.2 1.6 3.3 1.5 2.3c-.2-1.3.5-2.6.5-2.6l-1.1-2.2",
    fill: "#c6a397"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#e5c9bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2 37.9c.1.1-.1 1.9-.1 2.6c.1 1.3 2.5 2.6 2.1 1.7c-.6-1.2-.3-2.6-.3-2.6l-1.7-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2 33.3c0 .1-1.6 1.1-2.1 1.5c-.9.9-.5 3.6-.1 2.7c.6-1.2 1.8-1.9 1.8-1.9l.4-2.3"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7 32.4c1.2.1 2.9 2.5 3.4 3.6c.5 1.2 1.2 5 .5 5.2c-.9.3-3.9-2-4.6-3.3c-.6-1-.9-3.6-.4-4.7c0-.2.7-.8 1.1-.8",
    fill: "#d66b3c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagForAscensionIsland);
export default __webpack_public_path__ + "static/media/flag-for-ascension-island.68f3193c7bd8dd63350416011e1aedd1.svg";
export { ForwardRef as ReactComponent };